import * as Preact from "preact"

import App from "@fae/source/models/App.js"
import World from "@fae/source/models/World.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"
import * as PlotConditions from "@fae/source/data/plot/conditions.js"
import * as PlotScripts from "@fae/source/data/plot/scripts.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
import Geometry from "@fae/source/utility/Geometry.js"
import Step from "@fae/source/models/Step.js"
import Objdict from "objdict"

import ProgressReport from "@fae/source/data/games/school/views/ProgressReport.jsx"
import ProgressReportsHUD from "@fae/source/data/games/school/views/ProgressReportsHUD.jsx"
import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"

import HandleSlowDeath from "@fae/source/data/games/ember/scripts/HandleSlowDeath.js"
import HandleStatusEffects from "@fae/source/data/games/ember/scripts/HandleStatusEffects.js"
import HandleArmor from "@fae/source/data/games/ember/scripts/HandleArmor.js"
import GenerateStudents from "@fae/source/data/games/school/scripts/GenerateStudents.js"

import LevelUp from "@fae/source/data/games/school/scripts/LevelUp.jsx"
import ChapterSummary from "@fae/source/data/games/school/scripts/ChapterSummary.jsx"
import SavePlayerState from "@fae/source/data/games/school/scripts/SavePlayerState.js"

export default {
    "key": "opening",
    "stage": {
        "images": [
            {
                "url": require("../../dotgridbg.png"),
                "position": {"x": 0, "y": 0, "z": -1},
                "screenspace": "camera",
                "width": 16, "height": 9,
            },
            // {
            //     "url": require("./room.png"),
            //     "position": {"x": 0.8, "y": 0, "z": 2},
            //     "width": 16 * 1.15, "height": (1138 / 128) * 1.15,
            //     "isSquiggling": true,
            // },
            {
                "type": "lined-polygon",
                "position": {"x": 0, "y": 0, "z": 2},
                "points": require("./encounters.json")[0].points,
                "color": "#000",
                "isSquiggling": true,
            }
        ],
        "units": require("./units.json"),
        "world": World.parse({
            "width": 16,
            "height": 9,
            "blocks": require("./blocks.json"),
            "spots": require("./spots.json"),
            "encounters": require("./encounters.json"),
        }),
        "hud": function(stage) {
            if(stage?.flags["hud"] == "hidden") {
                return (
                    <div class="TutorialPrompt" isHidden={true}/>
                )
            }

            // return (
            //     <ProgressReportsHUD stage={stage}/>
            // )

            // if(stage.flags["tutorial:hasRallied"] != true) {
            //     return (
            //         <div class="TutorialPrompt" position="topright">
            //             <div class="Text">
            //                 The firekeeper has the power to RALLY her friends,
            //                 allowing them to act twice in a turn.
            //             </div>
            //         </div>
            //     )
            // }
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        },
        "scripts": [
            {
                "trigger": "turn:0:start",
                "events": [
                    Step.flag("hud", "hidden"),
                    PlotSteps.ReportStartingAnalytics(),
                    PlotSteps.SpawnPlayerParty({"spotTag": "goodspawn"}),
                    PlotSteps.PlayAudio("Ember:Music:Combat"),
                    GenerateStudents({
                        "unitCount": 1,
                        "jobKeys": ["school/sword"],
                        "level": 1,
                        "title": "Jock",
                        "images": {
                            "school/sword": require("@fae/source/assets/images/teach-tactics/mapsprite-JOCKRED.png"),
                        }
                    }),
                    "Jock: Lovely sunny day, wouldn't you say, WORM? On days like this shouldn't WORMS be in the ground?",
                    "Nerd: B-b-but I've got to prac-",
                    "Jock: Oh? What's this? A dork scroll? Some kind of cope?",
                    "Nerd: Hey, g-g-give it back!",
                    "Jock: A weakling like you just never has what it takes. Stop embarrassing Captain Prince and give up already",
                    PlotSteps.PerformAiActions(),
                    "Teacher: Oh? What have we here?",
                    "Jock: Teach! N-",
                    "Teacher: I'd say never giving up is *exactly* what makes powerful mages. If you cannot see this strength, then perhaps a demonstration is in order",
                    "Nerd: W-w-wait, I can't--",
                    "Teacher: I'll take the brunt of their strikes. Fire into the openings I cut for you and you'll get your practice",
                    Step.flag("modal", null),
                    Step.flag("hud", null),
                ]
            },
            {
                "type": "condition",
                "isWinCondition": true,
                "condition": (stage) => {
                    return PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": stage.player.affiliation})
                        || PlotConditions.areAllAffiliatedUnitsDefeated(stage, {
                            "affiliation": stage.player.affiliation,
                            "doNotIncludeUnitKey": "teacher"
                        })
                },
                "events": [
                    "Teacher: If these are our top students, then this school's attitudes really are rotten", "Teacher: What's this scroll? Some kind of self-written spell?",
                    "Nerd: Wait, m-m-my monograph! You don't need to read that. It's probably a waste of time",
                    "Teacher: Hmmmm, maybe... No, let's try this out. I think you can go far, with time",
                    "Nerd: Wait, m-m-me??",
                    PlotSteps.ChapterSuccess({"message": "Class Dismissed"}),
                    ChapterSummary(),
                    LevelUp(),
                    PlotSteps.TransitionStart({"isUnskippable": true}),
                    {"func": () => Navigation.go("/games/school/overworld")},
                    PlotSteps.TransitionEnd({"isUnskippable": true}),
                    PlotSteps.Wait(500),
                    {"func": () => App.game.player.overworld.currentTime += 1},
                    SavePlayerState(),
                ]
            },
            {
                "trigger": "turn:every-odd:end",
                "events": [
                    HandleSlowDeath(),
                    HandleStatusEffects(),
                    HandleArmor(),
                ]
            },
        ]
    },
}
